<template>
    <div>Here is really no content</div>
</template>

<script>
    export default {
        name: 'NoContent'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NoContent.vue